import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.LANGUAGE = 'en';

export default new Promise(resolve => {
  GoogleMapsLoader.load(resolve);
});
